/**
 * @author Christophe Convert
 * 
 */

export const WEBSITE_URL = process.env.REACT_APP_WEBSITE_URL ? process.env.REACT_APP_WEBSITE_URL : 'https://www.jurakko.io';

// ########################################## INFURA ####################################################################

export const INFURA_ID = process.env.REACT_APP_INFURA_ID ? process.env.REACT_APP_INFURA_ID : '0000';

// ########################################## CHAIN ID & ETHERSCAN ####################################################

export const POLYGONSCAN_CHAIN_ID = process.env.REACT_APP_POLYGONSCAN_CHAIN_ID ? parseInt(process.env.REACT_APP_POLYGONSCAN_CHAIN_ID,10) : 137;
export const POLYGONSCAN_TX_URL = process.env.REACT_APP_POLYGONSCAN_TX_URL ? process.env.REACT_APP_POLYGONSCAN_TX_URL : 'https://sepolia.etherscan.io/tx/';

// ########################################## UNISWAP ####################################################################

export const UNISWAP_URL= process.env.REACT_APP_UNISWAP_URL ? process.env.REACT_APP_UNISWAP_URL : ''; 

// ########################################## JURAKKO ERC20 #############################################################

export const JURAKKO_ERC20_ADDRESS = process.env.REACT_APP_JURAKKO_ERC20_ADDRESS ? process.env.REACT_APP_JURAKKO_ERC20_ADDRESS : '';
export const JURAKKO_ERC20_ABI = process.env.REACT_APP_JURAKKO_ERC20_ABI ? JSON.parse(process.env.REACT_APP_JURAKKO_ERC20_ABI) : '';
export const JURAKKO_ERC20_SYMBOL = process.env.REACT_APP_JURAKKO_ERC20_SYMBOL ? process.env.REACT_APP_JURAKKO_ERC20_SYMBOL : '';
export const JURAKKO_ERC20_DECIMALS = process.env.REACT_APP_JURAKKO_ERC20_DECIMALS ? parseInt(process.env.REACT_APP_JURAKKO_ERC20_DECIMALS,10) : 18;
export const JURAKKO_ERC20_IMAGE = process.env.REACT_APP_JURAKKO_ERC20_IMAGE ? process.env.REACT_APP_JURAKKO_ERC20_IMAGE : 'JKO.png';
export const POL_ERC20_IMAGE = process.env.REACT_APP_POL_ERC20_IMAGE ? process.env.REACT_APP_POL_ERC20_IMAGE : 'POL.png';

// ########################################## JURAKKO STAKING #################################################

export const JURAKKO_STAKING_ADDRESS = process.env.REACT_APP_JURAKKO_STAKING_ADDRESS ? process.env.REACT_APP_JURAKKO_STAKING_ADDRESS : '';
export const JURAKKO_STAKING_ABI = process.env.REACT_APP_JURAKKO_STAKING_ABI ? JSON.parse(process.env.REACT_APP_JURAKKO_STAKING_ABI) : '';

// ########################################## JURAKKO BOOKING #################################################

export const JURAKKO_BOOKING_ADDRESS = process.env.REACT_APP_JURAKKO_BOOKING_ADDRESS ? process.env.REACT_APP_JURAKKO_BOOKING_ADDRESS : '';
export const JURAKKO_BOOKING_ABI = process.env.REACT_APP_JURAKKO_BOOKING_ABI ? JSON.parse(process.env.REACT_APP_JURAKKO_BOOKING_ABI) : '';

// ########################################## JURAKKO BILL ####################################################

export const JURAKKO_BILL_ADDRESS = process.env.REACT_APP_JURAKKO_BILL_ADDRESS ? process.env.REACT_APP_JURAKKO_BILL_ADDRESS : '';
export const JURAKKO_BILL_ABI = process.env.REACT_APP_JURAKKO_BILL_ABI ? JSON.parse(process.env.REACT_APP_JURAKKO_BILL_ABI) : '';

// ########################################## JURAKKO ERC20 MARKETPLACE #############################################################

export const JURAKKO_ERC20_MARKETPLACE_ADDRESS = process.env.REACT_APP_JURAKKO_ERC20_MARKETPLACE_ADDRESS ? process.env.REACT_APP_JURAKKO_ERC20_MARKETPLACE_ADDRESS : '';
export const JURAKKO_ERC20_MARKETPLACE_ABI = process.env.REACT_APP_JURAKKO_ERC20_MARKETPLACE_ABI ? JSON.parse(process.env.REACT_APP_JURAKKO_ERC20_MARKETPLACE_ABI) : '';

// ########################################## JURAKKO ASSET MARKETPLACE #################################################

export const JURAKKO_ASSET_MARKETPLACE_ADDRESS = process.env.REACT_APP_JURAKKO_ASSET_MARKETPLACE_ADDRESS ? process.env.REACT_APP_JURAKKO_ASSET_MARKETPLACE_ADDRESS : '';
export const JURAKKO_ASSET_MARKETPLACE_ABI = process.env.REACT_APP_JURAKKO_ASSET_MARKETPLACE_ABI ? JSON.parse(process.env.REACT_APP_JURAKKO_ASSET_MARKETPLACE_ABI) : '';





